import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import {
   AddToCallListModalData,
   BulkChangeMessageTeamModalData,
   BulkSmsModalData,
   BulkWhatsappModalData,
   CandidateFormModalData,
   CandidatePoolModalData,
   CandidateSendFormModalData,
   ConfirmModalData,
   DraggableModalData,
   JobFunctionModalData,
   MinimizableModal,
   ProcessResumesModalData,
   ProcessResumesV2ModalData,
} from './modal.interface';

export interface ModalState {
   showConfirmModal: boolean;
   confirmModalData?: ConfirmModalData;

   showBulkSmsModal: boolean;
   bulkSmsModalData?: BulkSmsModalData;

   showBulkWhatsappModal: boolean;
   bulkWhatsappModalData?: BulkWhatsappModalData;

   showBulkChangeMessageTeamModal: boolean;
   bulkChangeMessageTeamModalData?: BulkChangeMessageTeamModalData;

   showCandidatePoolModal: boolean;
   candidatePoolModalData?: CandidatePoolModalData;

   showAddToCallListModal: boolean;
   addToCallListModalData?: AddToCallListModalData;

   showCandidateSendFormModal: boolean;
   candidateSendFormModalData?: CandidateSendFormModalData;

   showJobFunctionModal: boolean;
   jobfunctionModalData?: JobFunctionModalData;

   showDraggableModal: boolean;
   draggableModalData?: DraggableModalData;

   showCandidateFormModal: boolean;
   candidateFormModalData?: CandidateFormModalData;

   showProcessResumesModal: boolean;
   processResumesModalData?: ProcessResumesModalData;

   showProcessResumesV2Modal: boolean;
   processResumesV2ModalData?: ProcessResumesV2ModalData;

   minimizableModals: Array<MinimizableModal>;
}

const ModalStore: Module<ModalState, StoreState> = {
   namespaced: true,
   state: {
      showConfirmModal: false,
      showBulkSmsModal: false,
      showBulkWhatsappModal: false,
      showBulkChangeMessageTeamModal: false,
      showCandidatePoolModal: false,
      showAddToCallListModal: false,
      showCandidateSendFormModal: false,
      showJobFunctionModal: false,
      showDraggableModal: false,
      showCandidateFormModal: false,
      showProcessResumesModal: false,
      showProcessResumesV2Modal: false,
      minimizableModals: [],
   },
   getters: {},
   mutations: {
      SET_SHOW_CONFIRM_MODAL(state, value: boolean) {
         state.showConfirmModal = value;
      },
      SET_CONFIRM_MODAL_DATA(state, value?: ConfirmModalData) {
         state.confirmModalData = value;
      },
      // BULK SMS
      SET_SHOW_BULK_SMS_MODAL(state, value: boolean) {
         state.showBulkSmsModal = value;
      },
      SET_BULK_SMS_MODAL_DATA(state, value?: BulkSmsModalData) {
         state.bulkSmsModalData = value;
      },
      // BULK WHATSAPP
      SET_SHOW_BULK_WHATSAPP_MODAL(state, value: boolean) {
         state.showBulkWhatsappModal = value;
      },
      SET_BULK_WHATSAPP_MODAL_DATA(state, value?: BulkWhatsappModalData) {
         state.bulkWhatsappModalData = value;
      },
      // CHANGE MESSAGE TEAM
      SET_SHOW_BULK_CHANGE_MESSAGE_TEAM_MODAL(state, value: boolean) {
         state.showBulkChangeMessageTeamModal = value;
      },
      SET_BULK_CHANGE_MESSAGE_TEAM_MODAL_DATA(state, value?: BulkChangeMessageTeamModalData) {
         state.bulkChangeMessageTeamModalData = value;
      },
      // CANDIDATE POOL
      SET_SHOW_CANDIDATE_POOL_MODAL(state, value: boolean) {
         state.showCandidatePoolModal = value;
      },
      SET_CANDIDATE_POOL_MODAL_DATA(state, value: CandidatePoolModalData) {
         state.candidatePoolModalData = value;
      },
      // ADD TO CALL LIST
      SET_SHOW_ADD_TO_CALL_LIST_MODAL(state, value: boolean) {
         state.showAddToCallListModal = value;
      },
      SET_ADD_TO_CALL_LIST_MODAL_DATA(state, value: AddToCallListModalData) {
         state.addToCallListModalData = value;
      },
      // SEND FORM
      SET_SHOW_CANDIDATE_SEND_FORM_MODAL(state, value: boolean) {
         state.showCandidateSendFormModal = value;
      },
      SET_CANDIDATE_SEND_FORM_MODAL_DATA(state, value: CandidateSendFormModalData) {
         state.candidateSendFormModalData = value;
      },
      // JOB FUNCTIONS
      SET_SHOW_JOB_FUNCTION_MODAL(state, value: boolean) {
         state.showJobFunctionModal = value;
      },
      SET_JOB_FUNCTION_MODAL_DATA(state, value: JobFunctionModalData) {
         state.jobfunctionModalData = value;
      },
      SET_SHOW_CANDIDATE_FORM_MODAL_DATA(state, value: boolean) {
         state.showCandidateFormModal = value;
      },
      SET_CANDIDATE_FORM_MODAL_DATA(state, value: CandidateFormModalData) {
         state.candidateFormModalData = value;
      },
      // PROCESS RESUMES
      SET_SHOW_PROCESS_RESUMES_MODAL(state, value: boolean) {
         state.showProcessResumesModal = value;
      },
      SET_PROCESS_RESUMES_MODAL_DATA(state, value: ProcessResumesModalData) {
         state.processResumesModalData = value;
      },
      // PROCESS RESUMES V2
      SET_SHOW_PROCESS_RESUMES_V2_MODAL(state, value: boolean) {
         state.showProcessResumesV2Modal = value;
      },
      SET_PROCESS_RESUMES_V2_MODAL_DATA(state, value?: ProcessResumesV2ModalData) {
         state.processResumesV2ModalData = value;
      },
      // MINIMIZABLE
      ADD_MINIMIZABLE_MODAL(state, data: MinimizableModal) {
         state.minimizableModals.push({ ...data, id: `${Date.now().toString()}${Math.random()}` });
      },
      TOGGLE_MINIMIZABLE_MODAL(state, id: string) {
         const index = state.minimizableModals.findIndex((gm) => gm.id === id);
         if (index > -1) state.minimizableModals[index].minimized = !state.minimizableModals[index].minimized;
      },
      // Draggable
      SET_SHOW_DRAGGABLE_MODAL(state, value: boolean) {
         state.showDraggableModal = value;
      },
      SET_DRAGGABLE_MODAL_DATA(state, value: DraggableModalData) {
         state.draggableModalData = value;
      },

      DELETE_MINIMIZABLE_MODAL(state, id: string) {
         const index = state.minimizableModals.findIndex((gm) => gm.id === id);
         if (index > -1) state.minimizableModals.splice(index, 1);
      },
   },
   actions: {
      promptConfirmation(context, confirmModalData: ConfirmModalData) {
         context.commit('SET_SHOW_CONFIRM_MODAL', true);
         context.commit('SET_CONFIRM_MODAL_DATA', confirmModalData);
      },
      closeConfirmation(context) {
         context.commit('SET_SHOW_CONFIRM_MODAL', false);
         context.commit('SET_CONFIRM_MODAL_DATA', null);
      },
      // BULK SMS
      openBulkSmsModal(context, bulkSmsModalData: BulkSmsModalData) {
         context.commit('SET_SHOW_BULK_SMS_MODAL', true);
         context.commit('SET_BULK_SMS_MODAL_DATA', bulkSmsModalData);
      },
      closeBulkSmsModal(context) {
         context.commit('SET_SHOW_BULK_SMS_MODAL', false);
         context.commit('SET_BULK_SMS_MODAL_DATA', null);
      },
      // BULK WHATSAPP
      openBulkWhatsappModal(context, bulkWhatsappModalData: BulkWhatsappModalData) {
         context.commit('SET_SHOW_BULK_WHATSAPP_MODAL', true);
         context.commit('SET_BULK_WHATSAPP_MODAL_DATA', bulkWhatsappModalData);
      },
      closeBulkWhatsappModal(context) {
         context.commit('SET_SHOW_BULK_WHATSAPP_MODAL', false);
         context.commit('SET_BULK_WHATSAPP_MODAL_DATA', null);
      },
      // CHANGE MESSAGE TEAM
      openBulkChangeMessageTeamModal(context, bulkChangeMessageTeamModalData: BulkChangeMessageTeamModalData) {
         context.commit('SET_SHOW_BULK_CHANGE_MESSAGE_TEAM_MODAL', true);
         context.commit('SET_BULK_CHANGE_MESSAGE_TEAM_MODAL_DATA', bulkChangeMessageTeamModalData);
      },
      closeBulkChangeMessageTeamModal(context) {
         context.commit('SET_SHOW_BULK_CHANGE_MESSAGE_TEAM_MODAL', false);
         context.commit('SET_BULK_CHANGE_MESSAGE_TEAM_MODAL_DATA', null);
      },
      // CANDIDATE POOL
      openCandidatePoolModal(context, candidatePoolModalData: CandidatePoolModalData) {
         context.commit('SET_SHOW_CANDIDATE_POOL_MODAL', true);
         context.commit('SET_CANDIDATE_POOL_MODAL_DATA', candidatePoolModalData);
      },
      closeCandidatePoolModal(context) {
         context.commit('SET_SHOW_CANDIDATE_POOL_MODAL', false);
         context.commit('SET_CANDIDATE_POOL_MODAL_DATA', null);
      },
      // ADD TO CALL LIST
      openAddToCallListModal(context, addToCallListModalData: AddToCallListModalData) {
         context.commit('SET_SHOW_ADD_TO_CALL_LIST_MODAL', true);
         context.commit('SET_ADD_TO_CALL_LIST_MODAL_DATA', addToCallListModalData);
      },
      closeAddToCallListModal(context) {
         context.commit('SET_SHOW_ADD_TO_CALL_LIST_MODAL', false);
         context.commit('SET_ADD_TO_CALL_LIST_MODAL_DATA', null);
      },
      // SEND FORM
      openCandidateSendFormModal(context, candidateSendFormModalData: CandidateSendFormModalData) {
         context.commit('SET_SHOW_CANDIDATE_SEND_FORM_MODAL', true);
         context.commit('SET_CANDIDATE_SEND_FORM_MODAL_DATA', candidateSendFormModalData);
      },
      closeCandidateSendFormModal(context) {
         context.commit('SET_SHOW_CANDIDATE_SEND_FORM_MODAL', false);
         context.commit('SET_CANDIDATE_SEND_FORM_MODAL_DATA', null);
      },
      // JOB FUNCTIONS
      openJobFunctionModal(context, jobFunctionModalData: JobFunctionModalData) {
         context.commit('SET_SHOW_JOB_FUNCTION_MODAL', true);
         context.commit('SET_JOB_FUNCTION_MODAL_DATA', jobFunctionModalData);
      },
      closeJobFunctionModal(context) {
         context.commit('SET_SHOW_JOB_FUNCTION_MODAL', false);
         context.commit('SET_JOB_FUNCTION_MODAL_DATA', null);
      },
      // CANDIDATE
      openCandidateFormModal(context, data: CandidateFormModalData) {
         context.commit('SET_SHOW_CANDIDATE_FORM_MODAL_DATA', true);
         context.commit('SET_CANDIDATE_FORM_MODAL_DATA', data);
      },
      closeCandidateFormModal(context) {
         context.commit('SET_SHOW_CANDIDATE_FORM_MODAL_DATA', false);
         context.commit('SET_CANDIDATE_FORM_MODAL_DATA', null);
      },
      // Draggable
      openDraggableModal(context, data: DraggableModalData) {
         context.commit('SET_SHOW_DRAGGABLE_MODAL', true);
         context.commit('SET_DRAGGABLE_MODAL_DATA', data);
      },
      closeDraggableModal(context) {
         context.commit('SET_SHOW_DRAGGABLE_MODAL', false);
         context.commit('SET_DRAGGABLE_MODAL_DATA', null);
      },
      // PROCESS RESUMES
      openProcessResumesModal(context, data: ProcessResumesModalData) {
         context.commit('SET_SHOW_PROCESS_RESUMES_MODAL', true);
         context.commit('SET_PROCESS_RESUMES_MODAL_DATA', data);
      },
      closeProcessResumesModal(context) {
         context.commit('SET_SHOW_PROCESS_RESUMES_MODAL', false);
         context.commit('SET_PROCESS_RESUMES_MODAL_DATA', null);
      },
      // PROCESS RESUMES V2
      openProcessResumesV2Modal(context, data?: ProcessResumesV2ModalData) {
         context.commit('SET_SHOW_PROCESS_RESUMES_V2_MODAL', true);
         context.commit('SET_PROCESS_RESUMES_V2_MODAL_DATA', data);
      },
      closeProcessResumesV2Modal(context) {
         context.commit('SET_SHOW_PROCESS_RESUMES_V2_MODAL', false);
         context.commit('SET_PROCESS_RESUMES_V2_MODAL_DATA', null);
      },

      // MINIMAZABLE
      addMinimizableModal(context, data: MinimizableModal) {
         context.commit('ADD_MINIMIZABLE_MODAL', data);
      },

      toggleMinimizableModal(context, id: string) {
         context.commit('TOGGLE_MINIMIZABLE_MODAL', id);
      },

      deleteMinimizableModal(context, id: string) {
         context.commit('DELETE_MINIMIZABLE_MODAL', id);
      },
   },
};

export default ModalStore;
